export default {
  banner: {
    title: "Working in Authing",
    subtitle:
      "Become a member of a world-class team of experts in computer science, identity security, data and enterprise management",
  },
  comment: {
    title: "Authing in the team",
  },
  salary: {
    title: "Growing up in Authing",
    item1: {
      title: "Salary and year-end bonus",
      subtitle:
        "Authing provides salary comparable to that of big companies and considerable year-end bonus. We hope every member can get rich treatment while realizing personal value",
    },
    item2: {
      title: "Stock option",
      subtitle:
        "Authing has reserved a wealth of Option Shares. We hope every member and the company will grow together",
    },
    item3: {
      title: "Flexible work",
      subtitle:
        "Authing will never punch in and always adhere to the result orientation. We hope that the creativity of each member will not be framed by the system",
    },
    item4: {
      title: "Afternoon tea and snack shop",
      subtitle:
        "Authing has free afternoon tea every day, and the snack shop provides unlimited snacks",
    },
    item5: {
      title: "Focus on health",
      subtitle:
        "Authing provides a comprehensive physical examination for free. We hope every member can keep healthy",
    },
    item6: {
      title: "Team building",
      subtitle:
        "Authing organizes the team regularly and holds the birthday party every month. We hope every member can work hard and play hard",
    },
  },
  jobs: {
    title: "Open Positions",
    subtitle:
      'Please send your resume to: lewisli@authing.cn, the subject of the email is "Recruitment-Position Name-Name"',
    select: {
      "city-all": "All",
      "city-beijing": "Beijing",
      "city-shanghai": "Shanghai",
      "city-shenzhen": "Shenzhen",
      "type-all": "All",
      "type-product": "Product",
      "type-business": "Business",
      "type-other": "Other",
    },
    "button-apply": "Apply",
    job1: {
      title: "Safety Director",
      experience: "3-5 years / undergraduate",
      salary: "40-60k.15 salary",
      description: {
        item1:
          "Be responsible for the architecture, design and implementation of core safety and risk control products, and provide stable and reliable services;",
        item2:
          "Track the latest progress of data security, end security, anti cheating and other technologies and apply them to practice;",
        item3:
          "Be responsible for technical breakthrough and innovative technology introduction, and solve the problems of high performance, high concurrency and high reliability in the process of product development;",
        item4:
          "Investigate the company's R&D system and process, and give the platform design and technical scheme of corresponding underlying services;",
        item5:
          "Implement the design scheme into specific platform functions, continuously track the results and continuously optimize the user experience;",
      },
      skills: {
        item1:
          "More than 5 years of server development experience, in-depth understanding of UNIX / Linux;",
        item2:
          "Excellent coding ability, proficient in using Java or Golang, familiar with common algorithms, familiar with open source framework, strong problem-solving ability;",
        item3: "Rich experience in back-end program performance optimization;",
        item4:
          "Master the original and application of redis, mongodb, MySQL and other storage systems;",
        item5:
          "Have a certain understanding of the architecture design concept and motivation of distributed computing and distributed storage;",
        item6:
          "Network security or computer related major is preferred, and security related project experience is preferred;",
        item7:
          "Additional points: participated in the development and construction of security or risk control products in Internet companies; Experience in the design and development of large-scale back-end services.",
      },
    },
    job2: {
      title: "DevOps Director",
      experience: "3-5 years / undergraduate",
      salary: "40-60k.15 salary",
      description: {
        item1:
          "Be responsible for the construction and maintenance of automatic operation and maintenance platform and Devops system;",
        item2:
          "Responsible for developing tools and systems for life cycle, such as continuous integration, code release, capacity planning, monitoring, etc;",
      },
      skills: {
        item1:
          "Be familiar with at least one development language and have complete project development experience;",
        item2:
          "Familiar with cloud native architecture and common cloud platforms such as AWS, Alibaba cloud and Tencent cloud. Familiar with terrain choreography tools;",
        item3:
          "Be familiar with kubernetes technology and its principle, and have in-depth kubernetes practical experience;",
        item4:
          "Be familiar with automatic operation and maintenance management tools (puppet / saltstack / ansible), and hate manual operation;",
        item5:
          "Proficient in log processing and analysis, familiar with relevant components, such as Kafka, elk, flume, hive, storm, etc;",
        item6:
          "Experience in continuous integration, continuous delivery and automated release;",
        item7:
          "Strong learning ability, proactive, diligent, serious and down-to-earth;",
        item8:
          "Good ability to work under pressure and cross team cooperation and coordination, with a sense of service;",
        item9: "Participate in customer docking;",
        item10:
          "Additional points: participated in the establishment of a complete operation and maintenance system; Experience in asset management platform;",
      },
    },
    job3: {
      title: "Product Director",
      experience: "3-5 years / undergraduate",
      salary: "40-60k.15 salary",
      description: {
        item1:
          "According to the company's strategic needs, analyze, track and lead the situation and standards of idaas and identity cloud related industries and markets at home and abroad, and carry out medium and long-term planning and version planning of multiple product lines;",
        item2:
          "Manage the product team, formulate and improve the departmental norms and organizational structure, continuously optimize and improve the team ability and build a talent echelon;",
        item3:
          "Lead the team to complete product market demand analysis and application scenario analysis within the planned time, organize market research, deeply understand the opportunity points to improve user experience, and define product solutions and implementation plans;",
        item4:
          "Organize product manager to cooperate with project implementation, follow up product requirements and defects, and support project delivery and product sustainable development;",
        item5:
          "Operate around various product lines and corresponding markets, establish good user feedback, and improve products and communities;",
      },
      skills: {
        item1:
          "211 bachelor degree or above in unified recruitment of colleges and Universities;",
        item2:
          "Have excellent product planning ability and methodology, and be able to innovate and change existing business products;",
        item3:
          "More than 5 years of product manager experience, rich experience in 2B and 2C industry analysis, product planning, product and community operation, project support and commercial cooperation;",
        item4:
          "Pursue user experience, pain points and difficulties, have strong logic ability and excellent copywriting skills;",
        item5:
          "Role of lead product manager in successful large 2B / 2C products;",
        item6:
          "Strong curiosity, good analytical, executive and communication skills;",
        item7:
          "Technical background, good understanding of cloud computing related technologies and open source software;",
        item8: "Bonus: experience in computer software industry",
      },
    },
    job4: {
      title: "Content Operation",
      experience: "3-5 years / undergraduate",
      salary: "30-50k.15 salary",
      description: {
        item1:
          "Focus on Authing technology products and combined with user needs, develop and produce relevant content, such as product interpretation, industry solutions, customer case packaging, industry trends, data reports, digital transformation and other in-depth content output and dissemination, increase the reprint volume of authing articles included in Baidu and technology community, and stimulate users' interest in understanding authing, Reduce the learning cost, improve the understanding and recognition of Authing by developers, CIO / CTO and other technical user groups, and promote the growth and activity of users;",
        item2:
          "Carry out the whole process packaging in combination with the product content, complete the promotion of the company's product content in the technical group, build the content communication strategy, and be responsible for the content quality, reading, communication and promotion effect;",
        item3:
          "Cooperate with SEO / SEM team to plan and edit the content of the official website, and provide the key content output of brand, industry and product for the official website and technical community;",
        item4:
          "Explore and sort out content play methods, independently plan topics according to product iteration and market hot spots, guide users through operation means and shape brand reputation;",
        item5:
          "Be responsible for data sorting, analysis and replay after content dissemination, and guide product and content optimization direction and operation strategy with marketing data results;",
      },
      skills: {
        item1:
          "Bachelor degree or above, good at operation scheme design related to content operation and network communication;",
        item2:
          "Understand business, technology, tob / SaaS industry, enthusiasm and patience, and technical community operation experience is preferred;",
        item3:
          "Sense of Tob content operation and CTA (call to action) experience;",
        item4:
          "Journalists and editors with portal website / scientific and creative media / technology community are preferred, with strong communication skills, able to work under pressure, and willing to grow together with startups;",
        item5:
          "Be able to conduct effectiveness analysis through content dissemination data, solve problems through data drive, be good at fine operation, have clear objectives and be oriented by marketing results;",
        item6:
          "Bonus items: more than 5 years of working experience, plus points after graduation from journalism / advertising / marketing / computer related majors, experience in content operation in technical communities such as open source China, segmentfault and InfoQ, or experience as a reporter, editor, analyst of analysis institutions such as love analysis, iResearch and IDG, or consulting experience in scientific and creative media such as 36 krypton, Jiazi Lightyear and tiger sniff is preferred;",
      },
    },
    job5: {
      title: "CSM Director",
      experience: "3-5 years / undergraduate",
      salary: "40-60k.15 salary",
      description: {
        item1:
          "Be responsible for maintaining customer relationship, maintaining high customer satisfaction, practicing the principle of customer first, coordinating company resources, meeting customers' reasonable needs, and assisting customers to solve various situations in use;",
        item2:
          "Be responsible for product delivery and training implementation, assist customers to adjust systems and processes, regularly provide customers with data analysis, report customers' use, and provide customers with optimization schemes in combination with customers' needs;",
        item3:
          "Train the customer success manager to understand the implementation of new products and services;",
        item4:
          "Refine customer needs, understand product principles, promote new modules / services, and seek new growth points for customer success;",
        item5:
          "Complete the renewal rate index and consumption scenario expansion tasks, improve customer activity and boost the company's overall revenue;",
      },
      skills: {
        item1:
          "Working experience in customer success / Consultant position, working experience in SaaS industry and Internet industry is preferred;",
        item2:
          "Bachelor degree or above, software R&D background experience is preferred;",
        item3:
          "Serious and meticulous work, strong sense of responsibility, team consciousness and pressure resistance;",
        item4:
          "Be able to have an in-depth understanding of the business side of a customer's problem, not limited to technical problems;",
        item5:
          "Strong documentation ability, able to form written solutions for identity problems;",
        item6:
          "The ability to discover customer related problems and explore new directions at a certain level.",
      },
    },
    job6: {
      title: "Tiger Force- KA",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Responsible for the sales of important customers of authing Security Cloud products;",
        item2:
          "Sort out the sales opportunities in the target market, actively explore business opportunities, establish benchmark customers, and form a reproducible sales model;",
        item3:
          "Visit partners and customers regularly and maintain good business relations with partners and customers;",
        item4:
          "Timely update the company's product information, fully understand customer needs and actively follow up, formulate reasonable plans, and promote business negotiation and signing.",
      },
      skills: {
        item1:
          "Bachelor degree or above, major in computer, communication, marketing or other related majors;",
        item2:
          "At least 5 years to B sales experience, sales experience of VPN or other network security products, cloud products or channel sales experience in the same industry is preferred;",
        item3:
          "Good relationship building ability, excellent coordination ability, good team spirit, able to work under high pressure, strong self-motivated, and can adapt to short-term business trips;",
        item4:
          "Customers with Internet enterprises, central enterprises, finance, manufacturing and other industries are preferred.",
      },
    },
    job7: {
      title: "Tiger Force - SA",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Take KA customer breakthrough as the goal, insight into customer needs, design and develop supporting schemes and sales tools based on customer needs;",
        item2:
          "Lead and be responsible for the technical exchange of KA customers and complete the approval of schemes and products;",
        item3:
          "Lead R&D planning, participate in KA customer demand analysis, and help product design and improvement;",
        item4:
          "Corresponding to all pre-sales technical work related to the client.",
      },
      skills: {
        item1:
          "Familiar with it information construction in the industry, pre-sales and Party A engaged in relevant industries for more than 3-5 years;",
        item2:
          "Network security and cloud computing, proficient in technical solutions in at least one direction, and understand relevant products and mainstream technologies;",
        item3:
          "Have certain top-level design ability and solution writing ability, and have led the solution design of major projects in the corresponding industry.",
      },
    },
    job8: {
      title: "Front-end Engineer",
      experience: "3-5 years / undergraduate",
      salary: "20-40k.15 salary",
      description: {
        item1:
          "Participate in the design and implementation of the front and rear infrastructure of the company's external products, and provide stable and reliable services;",
        item2:
          "Responsible for the front and rear architecture design and implementation of the internal platform;",
        item3:
          "Be responsible for technical breakthrough and innovative technology introduction, and solve the problems of high performance, high concurrency and high reliability in the process of product development;",
        item4:
          "Investigate the company's R&D system and process, and give the platform design and technical scheme of corresponding underlying services;",
      },
      skills: {
        item1:
          "Proficient in HTML5, CSS3, JavaScript, solid computer foundation, familiar with data structure, network, etc;",
        item2:
          "In depth research on at least one MV * framework (such as react or Vue);",
        item3:
          "Understand the back-end technology stack, be familiar with the back-end language node.js, and be familiar with the cooperation mode with the back-end;",
        item4:
          "Have a certain understanding of user experience, interaction and user demand analysis, and experience in product or interface design is preferred;",
        item5:
          "Knowledge and practical experience of cloud computing, idaas or developer related products is preferred, and familiarity with serverless, FAAS and Devops related technologies is preferred;",
        item6:
          "Have high technical enthusiasm and enthusiasm, have good communication skills, can bear strong work pressure, have team spirit, can understand problems from the perspective of users, explore deficiencies and be good at summarizing;",
        item7:
          "Extra points: participated in or LED excellent open source projects; There are excellent technical blogs and blogs.",
      },
    },
    job9: {
      title: "Back-end Engineer",
      experience: "3-5 years / undergraduate",
      salary: "20-40k.15 salary",
      description: {
        item1:
          "Participate in the design and implementation of the front and rear infrastructure of the company's external products, and provide stable and reliable services;",
        item2:
          "Responsible for the front and rear architecture design and implementation of the internal platform;",
        item3:
          "Be responsible for technical breakthrough and innovative technology introduction, and solve the problems of high performance, high concurrency and high reliability in the process of product development.",
        item4:
          "Investigate the company's R&D system and process, and give the platform design and technical scheme of corresponding underlying services;",
        item5:
          "Implement the design scheme into specific platform functions, continuously track the results and continuously optimize the user experience;",
        item6:
          "Participate in the design of platform data structure and system architecture, and realize some services in the platform through node.js;",
        item7:
          "Responsible for the architecture design and implementation of the company's customer delivery projects;",
      },
      skills: {
        item1:
          "More than 3 years of Internet development experience, in-depth understanding of UNIX / Linux;",
        item2:
          "Excellent coding ability, proficient in node.js, familiar with common algorithms, familiar with open source framework, strong problem-solving ability;",
        item3:
          "Master the front-end framework react / Vue, and be familiar with the front-end engineering and component development mode;",
        item4: "Rich experience in back-end program performance optimization;",
        item5:
          "Master the principles and applications of redis, mongodb, MySQL and other storage systems;",
        item6:
          "Have a certain understanding of the architecture design concept and motivation of distributed computing and distributed storage;",
        item7:
          "Have a deep understanding of HTTP protocol and be familiar with TCP / IP and other network protocols;",
        item8:
          "Bonus items: experience in Python, go and PHP development; Participate in or own open source projects and contribute code to the open source community; Experience in the design and development of large-scale back-end services.",
      },
    },
    job10: {
      title: "Test Engineer",
      experience: "3-5 years / undergraduate",
      salary: "20-40k.15 salary",
      description: {
        item1:
          "Design test cases according to product requirements and test plans, execute test cases, and skillfully use bug management tools to submit and track;",
        item2:
          "Complete product integration test, system test, and comprehensive test of product interface and function;",
        item3:
          "Prepare relevant test reports according to the test process and cooperate with R&D personnel for functional commissioning;",
        item4:
          "As the central interface between business and product R & D, receive and analyze business demand problems and promote the improvement of product and R&D;",
        item5:
          "Responsible for introducing and improving new test methods to improve test efficiency;",
        item6:
          "Establish quality measurement standards to drive product quality improvement;",
      },
      skills: {
        item1: "At least 3 years QA experience, familiar with Web testing;",
        item2:
          "Be familiar with mobile terminal automation test framework and automation case writing, and be able to optimize the framework;",
        item3:
          "Familiar with Android / IOS platform features, have certain programming ability, and be familiar with Java language;",
        item4:
          "Familiar with HTTP protocol, restful API and working principle of Internet application;",
        item5: "Have a certain understanding of agile development and CI/CD;",
        item6:
          "Good communication and problem solving skills, good execution and driving force;",
        item7:
          "Be able to lead the team to do the last line of defense for the company.",
      },
    },
    job11: {
      title: "MDR",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Master the company's product knowledge and required business skills, communicate with target customers by telephone, answer customer calls, clarify the original clues from various channels, classify and grade according to specific standards, understand customer needs, budget, etc., match corresponding products and solutions, and look for sales cooperation opportunities;",
        item2:
          "Be responsible for undertaking, improving and sorting out market activities, websites and other channels to obtain customer information and business opportunities, transforming MQL (Marketing qualified leads) into sales leads after screening, inviting door-to-door, cooperating with sales to jointly promote signing and winning orders;",
        item3:
          "Actively reach unfamiliar customers through various marketing technical tools such as telephone, e-mail and micro channels (pulse, LinkedIn and trace), effectively communicate with key KP in line with customer portrait, convey product value, stimulate customer interest and invite successfully;",
        item4:
          "Through content, activities and communities, the capital continues to incubate potential customers, and can quickly and accurately find KP (key decision-maker) through communication and exchange, so as to output high-quality clues for sales;",
        item5:
          "Conduct preliminary screening of network clues and clues obtained from market activities, and output effective clues through telephone expansion when there is not enough online clues;",
        item6:
          "Analyze customer needs, summarize market and industry characteristics and laws, and put forward constructive market development plans for growth and sales departments.",
        item7: "Complete the temporary work assigned by the leader;",
      },
      skills: {
        item1:
          "College degree or above, with more than 2 years of relevant working experience in 2B sales, telemarketing, customer service, outbound call, early customer development, customer incubation and cultivation is preferred;",
        item2:
          "Working experience in startups / tob SaaS industry is preferred;",
        item3:
          "Don't contradict to call, talk naturally, have strong pressure resistance, don't have a glass heart, solid skin and strong communication skills;",
        item4:
          "Clear thinking logic, good voice conditions (standard Mandarin, clear articulation, cordial and magnetic), strong pressure resistance, and dare to take the challenge of high salary;",
        item5:
          "Good communication, expression and understanding skills, and can quickly assist customers;",
      },
    },
    job12: {
      title: "SDR",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Quickly learn the company's products and business, clarify the development direction of customer groups and formulate development plans;",
        item2:
          "Mainly by telephone, reach the target customers through a variety of ways, including but not limited to outbound list, pulse, LinkedIn, exhibition and other forms, establish effective contacts and output sales leads;",
        item3:
          "After the clues are transformed into effective business opportunities, they are assigned to the sales team, synchronize specific information with the sales team, and assist in completing the follow-up visit and follow-up of customers;",
        item4:
          "Establish detailed customer files and development records, continuously optimize development strategies, and improve the transformation from clues to business opportunities;",
        item5:
          "Assess the behavior indicators and performance indicators quarterly and monthly, and provide dual performance incentives for behavior and performance.",
      },
      skills: {
        item1:
          "College degree or above, more than two years of telemarketing experience, or more than one year of Tob software sales experience (SaaS products are preferred);",
        item2: "Have qualified sales ability of coldcall;",
        item3: `Have a keen sense of customer / market "smell" and a strong sense of self time management;`,
        item4:
          "He is honest, diligent and down-to-earth, and has strong skin and pressure resistance.",
      },
    },
    job13: {
      title: "Product Manager (delivery)",
      experience: "3-5 years / undergraduate",
      salary: "15-30k.15 salary",
      description: {
        item1:
          "As the project leader, be responsible for the implementation of key customers and the management of delivery projects;",
        item2:
          "Sort out the current situation of customer organizational structure, decision-making process and data capability, formulate corresponding delivery strategies, and lead team members to land with customers;",
        item3:
          "Continue to promote the use depth and breadth of authing products on the customer side, find customers' business demands and cooperation opportunities, and work with project members to provide customers with effective data solutions;",
        item4:
          "Participate in the review in the pre-sales stage of the project to avoid contract risks and ensure the successful delivery of the project.",
      },
      skills: {
        item1:
          "Bachelor degree or above, major in computer, finance, statistics and mathematics is preferred;",
        item2:
          "Have tob enterprise service experience, master project management work and methods, and more than 2 years of practical project management experience;",
        item3:
          "Have working experience in industry benchmark enterprises and well-known foreign enterprise consulting companies, and be familiar with business scenarios such as product iteration and user operation;",
        item4:
          "Have good pressure resistance, communication skills and teamwork spirit;",
        item5:
          "IAM / IDaaS / security / cloud computing delivery project background, data-driven business development experience is preferred;",
        item6: "Fast learning ability; Strong initiative;",
      },
    },
    job14: {
      title: "Product Manager (end B)",
      experience: "3-5 years / undergraduate",
      salary: "30-40k.15 salary",
      description: {
        item1:
          "Responsible for product design, including product architecture and platform system construction, and be able to innovate product model;",
        item2:
          "Study market demand and use scenarios, and build standardized product solutions through demand research, function design, strategy formulation and effect improvement;",
        item3:
          "Collect and analyze market and competitive information, carry out product planning, and be able to evaluate the overall effect of products;",
        item4:
          "Cooperate with the team to complete the project review, planning, coordination and communication of products, track and promote, and ensure the output of product iteration;",
        item5:
          "Efficiently cooperate with market, R&D and operation teams to achieve goals;",
        item6: "Responsible for product growth function iteration;",
        item7: "Responsible for product brand building.",
      },
      skills: {
        item1:
          "Commercial product experience, building a commercial system from 0 to 1 is preferred;",
        item2:
          "Good technical ability, more than 1 year of software R&D experience, cloud computing, Iam, idaas related working experience is preferred;",
        item3:
          "Be familiar with the whole commercialization chain and understand the commercialization mode and product design method of mainstream platforms;",
        item4: "Participated in product from 0 to 1;",
        item5: "Can be independent;",
        item6:
          "Good communication and coordination skills, able to cooperate with different team members and bear great pressure.",
      },
    },
    job15: {
      title: "UI Designer",
      experience: "3-5 years / undergraduate",
      salary: "15-30k.15 salary",
      description: {
        item1: "Responsible for PC interface design and interaction design;",
        item2:
          "Participate in product requirements and design review, provide feasible design solutions, and have in-depth research and understanding of interaction and UI design;",
        item3:
          "Responsible for design review and quality control of the project, promote design innovation and summarize design methodology;",
        item4:
          "Track the implementation and launch of the scheme, follow up the R&D process and the design acceptance of the final product, and ensure the design restoration quality;",
      },
      skills: {
        item1:
          "Bachelor degree or above, major in design, at least 2 years of Internet (b-end) design experience;",
        item2:
          "Have rigorous logical thinking ability, can quickly understand the product and decompose the design requirements, and complete the design requirements independently;",
        item3:
          "Have good aesthetics, keen design insight and forward-looking design concept, communication and cooperation consciousness and good coordination and organization ability;",
      },
    },
    job16: {
      title: "Sales Operation",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "According to the overall sales target of the Department, track and analyze the sales performance progress, and give business guidance and suggestions;",
        item2:
          "Be responsible for improving the sales process, follow-up management of the process, and promoting the implementation of various sales management systems and processes;",
        item3:
          "Cooperation and communication across business lines and departments in the process of sales management to ensure the orderly and efficient operation of all work;",
        item4:
          "According to different business stages and the actual business situation of each project, formulate and implement the sales strategy, track and adjust the activity progress, adjust the strategy in time, and complete the resumption and continuous optimization;",
        item5:
          "Complete the disassembly and target setting of various sales operation work, build and manage the sales operation team;",
        item6:
          "Familiar with CRM system and financial data analysis, can timely help the company put forward more reasonable suggestions and Optimization in CRM system according to business development;",
      },
      skills: {
        item1:
          "Sales operation experience is preferred, more than 5 years of relevant working experience;",
        item2:
          "Quick thinking, good analytical and problem solving skills, and can actively promote business development;",
        item3:
          "Good cross departmental communication and cooperation ability, self driving ability and organizational ability, able to take the initiative and keep an eye on the sales progress;",
        item4:
          "Familiar with SaaS or to B business, able to quickly cooperate with the company's management to understand the business direction;",
        item5:
          "Relevant financial experience, familiar with multi-dimensional tools required for digital operation; Provide risk prediction in digital dimension;",
        item6: "Good English, proficient in reading and writing.",
      },
    },
    job17: {
      title: "Implementation Engineer",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Be responsible for POC (proof of concept) or demo construction for high intention customers, and assist in sales and pre-sales promotion projects;",
        item2:
          "Responsible for project delivery and Implementation for signed customers to ensure the smooth completion of the project;",
        item3:
          "Be responsible for supporting and maintaining customers who have implemented authing software solutions and responding to customers' technical problems in time;",
        item4:
          "Proficient in using authing API / SDK and solving technical problems for customers.",
      },
      skills: {
        item1:
          "Master the basic knowledge of software development and general architecture;",
        item2: "Have HTTP knowledge, encryption and basic security concepts;",
        item3:
          "Proficient in at least one programming language, preferably node.js and Java;",
        item4:
          "At least 2 years of technical support or software development experience;",
        item5:
          "Understand the concepts of authentication and permissions (plus points)",
        item6:
          "Understand at least one identity authentication protocol: oauth2, oidc, SAML, ws-fed, LDAP, azure ad, etc. (plus points)",
      },
    },
    job18: {
      title: "Pre-sales Engineer",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Be responsible for cooperating with the Department to complete project clue tracking, demand analysis, construction planning, technical scheme and bidding;",
        item2:
          "Be responsible for pre-sales handover to make the project enter POC or after-sales implementation stage smoothly;",
        item3:
          "Be responsible for the precipitation of industry knowledge and skills, and improve and update the pre-sales database such as solutions and cases.",
      },
      skills: {
        item1: "At least 2 years experience in front-line R&D position;",
        item2:
          "At least 3 years of pre-sales engineering experience, and has been responsible for the overall process of large-scale projects;",
        item3:
          "Have the ability of business demand analysis, language expression, logical thinking and text organization;",
        item4:
          "Have the ability to write presentation documents, technical and service plans, project bids and project proposals independently;",
        item5:
          "Experience in technology implementation in complex solution environment;",
        item6:
          "Have time management, project management skills, and multi department cooperation ability.",
      },
    },
    job19: {
      title: "Commercialization KA",
      experience: "3-5 years / undergraduate",
      salary: "salary negotiable",
      description: {
        item1:
          "Be familiar with the industry and market information of the company's identity cloud products, and learn and master the company's products;",
        item2:
          "Explore potential customers through partners and meetings, explore new markets, be responsible for the decomposition of sales objectives and the achievement of sales targets;",
        item3:
          "Guide customer demand analysis and actively follow up, project application, solution creation, business negotiation, bidding, etc;",
        item4:
          "Cooperate and coordinate with pre-sales department, form orders efficiently, and follow up project receivables, and complete sales collection indicators on time;",
        item5:
          "Formulate daily, weekly and monthly sales plans and feed back sales results;",
        item6:
          "Assist in research and analysis of competitive products to ensure fast iteration of Authing.",
      },
      skills: {
        item1:
          "Bachelor degree or above, major in computer, communication and software, and have a basic understanding of it fields such as software, network and cloud;",
        item2:
          "More than 5 years of software sales experience in to B, familiar with SaaS market is preferred;",
        item3:
          "Strong business development ability, communication and coordination ability, negotiation ability, keen market insight and innovation ability;",
        item4:
          "Have a strong sense of purpose and execution, be good at self motivation, pay attention to commitment, and have strong pressure resistance;",
        item5:
          "Experience in identity, information security, cloud computing, idaas or it developer docking is preferred;",
        item6:
          "Responsible for the development of key customers, including finance, new retail, manufacturing, high technology, Internet, government and other industries. If necessary, travel is required.",
      },
    },
  },
  "job-detail": {
    publishtimer: "Release time",
    "label-description": "Job Description",
    "label-skills": "Job Requirements",
    "label-newjob": "Latest position",
    "button-apply": "Apply now",
    navbar: {
      nav0: "About Authing",
      nav1: "Join us",
    },
  },
};
